module.exports = "/fonts/vendor/summernote/dist/summernote.eot?69d43255ae404d80f6410bd06fd5511c";


//////////////////
// WEBPACK FOOTER
// ./~/summernote/dist/font/summernote.eot
// module id = 86
// module chunks = 0